import PaymentInfoModule, {PaymentInfoModuleProps} from './PaymentInfoModule';

export type {PaymentInfoModuleProps};
export default PaymentInfoModule;
